import { Link } from "react-router-dom";
import { useCookieConsentStore } from "@shared/store/cookie-consent.store";
import { Banner } from "@shared/ui/components/banner";
import { Button } from "@shared/ui/components/button";

export const CookieConsent = (): JSX.Element | null => {
  const { accepted, setAccepted } = useCookieConsentStore();

  if (accepted) {
    return null;
  }

  return (
    <div className="fixed bottom-2 left-4 right-4 sm:bottom-4 sm:left-4 sm:right-6 md:left-auto md:right-6 lg:right-8 z-50 max-w-[calc(100%-2rem)] sm:max-w-md w-auto md:w-full mx-auto md:mx-0">
      <Banner variant="muted" className="shadow-lg flex-col items-stretch gap-3 sm:flex-row sm:items-center p-3 sm:p-4">
        <p className="text-xs sm:text-sm leading-snug">
          Мы используем cookie для работы сайта и аналитики. Продолжая пользоваться сайтом, вы соглашаетесь с{" "}
          <Link to="/privacy" className="underline underline-offset-2 hover:text-foreground">
            политикой конфиденциальности
          </Link>
          .
        </p>
        <Button size="sm" className="shrink-0 self-end sm:self-auto" onClick={() => setAccepted(true)}>
          Принять
        </Button>
      </Banner>
    </div>
  );
};
